define('enums/qm/calibrationCreateModes',[],function () {
    'use strict';

    return {
        BASIC: 'BASIC',
        EXPERT_EVALUATOR: 'EXPERT_EVALUATOR',
        EXISTING_EVALUATION: 'EXPERT_EVALUATION'
    };
});
